<template>
  <v-container>
    <v-card class="elevation-2 pa-4 lease-card">
      <!-- Title -->
      <v-card-title class="headline primary--text">
        Lease Details
      </v-card-title>
      <v-divider class="mb-4"></v-divider>

      <!-- Form -->
      <v-form @submit.prevent="submitDetails">
        <!-- Lease Type -->
        <v-select 
          v-model="details.type" 
          :items="['Fixed Term Lease', 'Month to Month Lease']" 
          label="Lease Type" 
          outlined 
          dense 
          required 
          class="form-field">
        </v-select>

        <!-- Start Date -->
        <v-text-field 
          v-model="details.startDate" 
          label="Start Date" 
          type="date" 
          outlined 
          dense 
          required 
          class="form-field">
        </v-text-field>

        <!-- End Date -->
        <v-text-field 
          v-model="details.endDate" 
          label="End Date" 
          type="date" 
          outlined 
          dense 
          required 
          class="form-field">
        </v-text-field>

        <!-- Rent Due Frequency -->
        <v-select 
          v-model="details.rentDueFrequency" 
          :items="['1st of each Month', 'Weekly', 'Yearly', 'Daily', 'Every two weeks', 'Every two months', 'Every three months (Quarterly)', 'Every four months', 'Every five months', 'Every six months', 'Every seven months', 'Every eight months', 'Every nine months', 'Every ten months', 'Every eleven months']" 
          label="Rent Due Frequency" 
          outlined 
          dense 
          required 
          class="form-field">
        </v-select>

        <!-- Due Day -->
        <v-select 
          v-model="details.dueDay" 
          :items="['1st of each Month']" 
          label="Due Day" 
          outlined 
          dense 
          required 
          class="form-field">
        </v-select>

        <!-- Rental Amount -->
        <v-text-field 
          v-model="details.rentalAmount" 
          label="Rental Amount (R)" 
          outlined 
          dense 
          required 
          class="form-field" 
          :rules="[value => !value || value > 0 || 'Rental amount must be positive']"
          @input="formatCurrency">
        </v-text-field>

        <!-- Invoice Date -->
        <v-text-field 
          v-model="details.invoiceDate" 
          label="Invoice Date" 
          type="date" 
          outlined 
          dense 
          required 
          class="form-field">
        </v-text-field>

        <!-- Prorated Amount -->
        <v-text-field 
          v-model="details.prorataAmount" 
          label="Prorated Amount (R)" 
          outlined 
          dense 
          required 
          class="form-field" 
          :rules="[value => !value || value > 0 || 'Prorated amount must be positive']"
          @input="formatCurrency">
        </v-text-field>

        <!-- Submit Button -->
        <v-btn type="submit" color="primary" class="mt-4 submit-button">
          Submit Lease Details
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      details: {
        type: '', // Lease type (e.g., Fixed Term Lease)
        startDate: '', // Lease start date
        endDate: '', // Lease end date
        rentDueFrequency: '', // Frequency of rent due (Monthly, Weekly, etc.)
        dueDay: '', // Day of rent due
        rentalAmount: '', // Rental amount
        invoiceDate: '', // Date of the first rental invoice
        prorataAmount: '', // Prorated rental amount
      },
    };
  },
  methods: {
    submitDetails() {
      // Emit the lease details object for processing or saving
      this.$emit('leaseDetailsSubmitted', this.details);
    },
    formatCurrency(event) {
      // Format the value as currency with 'R' symbol
      let value = event.target.value.replace(/[^0-9.-]+/g, ''); // Remove any non-numeric characters
      if (value) {
        value = parseFloat(value).toFixed(2); // Format with 2 decimal places
        this.details[event.target.name] = 'R' + value; // Update the model with the formatted value
      }
    },
  },
};
</script>

<style scoped>
/* General card styling */
.lease-card {
  max-width: 600px;
  margin: 20px auto;
  background-color: #f9f9f9;
  border-radius: 12px;
}

/* Headline styling */
.primary--text {
  color: #1976d2; /* Vuetify primary color */
  font-weight: bold;
  font-size: 20px;
}

/* Form field spacing */
.form-field {
  margin-bottom: 16px;
}

/* Button styling */
.submit-button {
  width: 100%;
  color: white;
  font-weight: bold;
}
</style>
